import React from 'react';
import { gradeColors } from './Constants';

/* column order + human labels */
export const ratingLabels = {
  rating: 'Overall', conceptrating: 'Concept',  plotrating: 'Plot',
  charactersrating: 'Characters', emotional_impact: 'Emotional Impact',
  conflict_level: 'Conflict Level', dialoguerating: 'Dialogue',
  storyforward: 'Story Forward', characterchanges: 'Character Changes',
  highstakes: 'High Stakes', internal_goal_score: 'Internal Goal',
  external_goal_score: 'External Goal', originality_score: 'Originality',
  engagement_score: 'Engagement', pacing_score: 'Pacing',
  formatting_score: 'Formatting', structure_score : 'Structure',
};
const ratingKeys = Object.keys(ratingLabels);

export default function RatingsMatrix({ rows /* [{label,ratings}] */ }) {
  /* find best number in each column ─ used for purple badge */
  const best = {};
  ratingKeys.forEach(k => {
    best[k] = Math.max(
      ...rows.map(r => Number.isFinite(+r.ratings?.[k]) ? +r.ratings[k] : -Infinity),
    );
  });

  return (
    <div className="table-responsive">
      <table className="table table-sm table-striped align-middle text-center">
        <thead>
          <tr>
            <th style={{width:'13rem'}}>Version</th>
            {ratingKeys.map(k => <th key={k}>{ratingLabels[k]}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map(({ label, ratings }) => (
            <tr key={label}>
              {/* <td className="text-start fw-bold">{label}</td> */}
{/* inside the tr for each version row (incl. original) */}
<td className="text-nowrap">
  {g.isOriginal ? (
    'Original'
  ) : (
    <button
      className="btn btn-link p-0"
      data-bs-toggle="modal"
      data-bs-target={`#genModal${g.uuid}`}
    >
      {new Date(g.created_at).toLocaleString()}
    </button>
  )}
</td>
              {ratingKeys.map(k => {
                const v  = Number.isFinite(+ratings?.[k]) ? +ratings[k] : '—';
                const bg = Number.isFinite(+v) ? gradeColors[Math.round(v)] : 'transparent';
                const badge = v === best[k];
                return (
                  <td key={k} style={{ backgroundColor: bg, position:'relative' }}>
                    {badge ? (
                      <span
                        style={{
                          display:'inline-block', minWidth:32, padding:'4px 0',
                          borderRadius:'50%', border:'2px solid purple', fontWeight:600,
                        }}>
                        {v}
                      </span>
                    ) : v}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
